import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { renderKoDataTable, renderKoInputCell } from '~/components/templates/listPageDataTable';
import { renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { listPageSelect_template } from '~/components/templates/listPageSelect_template';
import { html, LpButton, LpEditCard, LpEditGrid, LpEditSteps, LpEditTabs, LpFormField, LpPageHeader, LpTable, raw } from '~/design-system';
export class adminTrackingContractEdit_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminTrackingContractEdit-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        const viewModel = {
            id: ko.observable(null),
            name: ko.observable(''),
            campaignCode: ko.observable(''),
            channel: ko.observable('REC'),
            startDate: ko.observable(''),
            endDate: ko.observable(''),
            agency: ko.observable(''),
            deliveryMethod: ko.observable(''),
            salesRep: ko.observable(''),
            notes: ko.observable(''),
            weeklyMaxVolume: ko.observable(''),
            dailyMaxVolume: ko.observable(''),
            targetLeadSold: ko.observable(''),
            uniqueLeads: ko.observable(''),
            badLeadsPercent: ko.observable(''),
            badLeadsFlat: ko.observable(''),
            quotaAlert: ko.observable('1'),
            automaticTurnOnOff: ko.observable(''),
            automaticTurnOn: ko.observable('1'),
            automaticTurnOff: ko.observable('1'),
            priceFlat: ko.observable(''),
            campaignCodesText: ko.observable(''),
            currentTrackingMonths: ko.observableArray([]),
            partners: ko.observableArray([]),
            selectedPartnerIds: ko.observableArray([]),
            channels: ko.observableArray([]),
            agencies: ko.observableArray([]),
            salesReps: ko.observableArray([]),
            priceTiers: ko.observableArray(self.getPriceTierRows()),
            monthlyQuotas: ko.observableArray(self.getMonthlyQuotaRows()),
            dailyQuotas: ko.observableArray(self.getDailyQuotaRows()),
            activeSection: ko.observable('campaign'),
            sections: [
                { id: 'campaign', label: 'Campaign', icon: 'megaphone' },
                { id: 'partners', label: 'Partners', icon: 'users' },
                { id: 'pricing', label: 'Pricing', icon: 'currency-dollar' },
                { id: 'quotas', label: 'Quotas', icon: 'gauge' },
                { id: 'automation', label: 'Automation', icon: 'gear' },
            ],
            onClickSection: function (section) { self.selectSection(section.id); },
            onClickPrevious: function () { self.goToPreviousSection(); },
            onClickNext: function () { self.goToNextSection(); },
            onClickBack: function () { self.caller.backToContracts(); },
            onClickSave: function () { self.caller.saveContract(); },
        };
        viewModel.startDate.subscribe(function () {
            self.refreshMonthlyRows(viewModel);
        });
        viewModel.endDate.subscribe(function () {
            self.refreshMonthlyRows(viewModel);
        });
        return viewModel;
    }
    /**
     * Register computed view-model properties after the template VM is assigned.
     *
     * @return void
     */
    initPartial() {
        const self = this;
        const vm = this.getTemplateViewModel();
        this.channelSelect = this.createFormSelect('adminContractChannelSelect', 'Channel', vm.channel, [
            { id: '', name: 'Select channel' },
        ]);
        this.agencySelect = this.createFormSelect('adminContractAgencySelect', 'Agency', vm.agency, [
            { id: '', name: 'Select agency' },
        ]);
        this.salesRepSelect = this.createFormSelect('adminContractSalesRepSelect', 'Sales Rep', vm.salesRep, [
            { id: '', name: 'Select sales rep' },
        ]);
        vm.sectionCompletion = ko.computed(function () {
            return self.getSectionCompletion();
        });
        vm.isFirstSection = ko.computed(function () {
            return self.getSectionIndex(vm.activeSection()) === 0;
        });
        vm.isLastSection = ko.computed(function () {
            return self.getSectionIndex(vm.activeSection()) === self.getSectionIds().length - 1;
        });
    }
    createFormSelect(id, label, valueBinding, options) {
        const select = new listPageSelect_template(id, this.getTemplateViewModel(), this.caller);
        select.setLabel(label);
        select.setFormField(true);
        if (options) {
            select.setOptions(options);
        }
        select.bindValue(valueBinding);
        return select;
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: html `<span data-bind="text: id() ? 'Edit Contract' : 'New Contract'"></span>`,
            description: 'Define campaign settings, partners, pricing, quotas, and automation.',
            icon: 'file-text',
            actions: html `
                    ${LpButton({
                label: 'Back',
                prefixIcon: 'arrow-left',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickBack',
                },
            })}
                    ${LpButton({
                label: 'Save',
                prefixIcon: 'check',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickSave',
                },
            })}
                `,
        })}

            <div class="edit-page">
                ${LpEditTabs({ ariaLabel: 'Contract sections' })}

                <div class="contract-edit-panel">
                ${LpEditCard({
            title: 'Campaign',
            description: 'Define the campaign identity, schedule, and ownership.',
            attributes: {
                'data-bind': "visible: activeSection() === 'campaign'",
            },
            children: LpEditGrid({
                children: html `
                            ${LpFormField({
                    label: 'Campaign Name',
                    required: true,
                    children: raw('<input class="edit-input" type="text" placeholder="Campaign name" data-bind="value: name" />'),
                })}
                            ${LpFormField({
                    label: 'Campaign Code',
                    children: raw('<input class="edit-input" type="text" placeholder="Tracking campaign code" data-bind="value: campaignCode" />'),
                })}
                            ${LpFormField({
                    label: 'Channel',
                    children: raw(this.channelSelect.getHtmlBuild()),
                })}
                            ${LpFormField({
                    label: 'Start Date',
                    required: true,
                    children: raw('<input class="edit-input" type="date" data-bind="value: startDate" />'),
                })}
                            ${LpFormField({
                    label: 'End Date',
                    required: true,
                    children: raw('<input class="edit-input" type="date" data-bind="value: endDate" />'),
                })}
                            ${LpFormField({
                    label: 'Agency',
                    children: raw(this.agencySelect.getHtmlBuild()),
                })}
                            ${LpFormField({
                    label: 'Sales Rep',
                    children: raw(this.salesRepSelect.getHtmlBuild()),
                })}
                            ${LpFormField({
                    label: 'Additional Campaign Codes',
                    className: 'edit-span',
                    children: raw('<textarea class="edit-input edit-textarea" rows="3" placeholder="One code per line or comma separated" data-bind="value: campaignCodesText"></textarea>'),
                })}
                        `,
            }),
        })}

                ${LpEditCard({
            title: 'Partners',
            description: 'Select the partners included in this contract.',
            attributes: {
                'data-bind': "visible: activeSection() === 'partners'",
            },
            children: LpEditGrid({
                children: LpFormField({
                    label: 'Assigned Partners',
                    required: true,
                    className: 'edit-span',
                    children: raw('<select class="edit-input contract-edit-multiselect" multiple data-bind="selectedOptions: selectedPartnerIds, options: partners, optionsText: \'name\', optionsValue: \'id\'"></select>'),
                }),
            }),
        })}

                ${LpEditCard({
            title: 'Commercial Details',
            description: 'Configure pricing, delivery, and bad lead adjustments.',
            attributes: {
                'data-bind': "visible: activeSection() === 'pricing'",
            },
            children: html `
                        ${LpEditGrid({
                children: html `
                                ${LpFormField({
                    label: 'Flat Price',
                    children: raw('<input class="edit-input" type="number" step="0.0001" data-bind="value: priceFlat" />'),
                })}
                                ${LpFormField({
                    label: 'Delivery Method',
                    children: raw('<input class="edit-input" type="number" data-bind="value: deliveryMethod" />'),
                })}
                                ${LpFormField({
                    label: 'Bad Leads %',
                    children: raw('<input class="edit-input" type="number" step="0.0001" data-bind="value: badLeadsPercent" />'),
                })}
                                ${LpFormField({
                    label: 'Bad Leads Flat',
                    children: raw('<input class="edit-input" type="number" data-bind="value: badLeadsFlat" />'),
                })}
                            `,
            })}
                        ${raw(this.getPriceTiersTableHtml())}
                    `,
        })}

                ${LpEditCard({
            title: 'Quotas',
            description: 'Monthly max caps control the effective cap. Sold leads are read-only values from tracking month rows.',
            attributes: {
                'data-bind': "visible: activeSection() === 'quotas'",
            },
            children: html `
                        ${LpEditGrid({
                children: html `
                                ${LpFormField({
                    label: 'Weekly Max Volume',
                    children: raw('<input class="edit-input" type="number" data-bind="value: weeklyMaxVolume" />'),
                })}
                                ${LpFormField({
                    label: 'Daily Max Volume',
                    children: raw('<input class="edit-input" type="number" data-bind="value: dailyMaxVolume" />'),
                })}
                                ${LpFormField({
                    label: 'Target Lead Sold',
                    children: raw('<input class="edit-input" type="number" data-bind="value: targetLeadSold" />'),
                })}
                                ${LpFormField({
                    label: 'Unique Leads',
                    children: raw('<input class="edit-input" type="number" data-bind="value: uniqueLeads" />'),
                })}
                            `,
            })}
                        ${raw(this.getMonthlyQuotasTableHtml())}
                        <h3 class="contract-edit-subsection">Daily Max Quota</h3>
                        ${raw(this.getDailyQuotasTableHtml())}
                    `,
        })}

                ${LpEditCard({
            title: 'Automation',
            description: 'Configure quota alerts and automatic on/off rules.',
            attributes: {
                'data-bind': "visible: activeSection() === 'automation'",
            },
            children: LpEditGrid({
                children: html `
                            ${LpFormField({
                    label: 'Quota Alert',
                    children: raw('<input class="edit-input" type="number" data-bind="value: quotaAlert" />'),
                })}
                            ${LpFormField({
                    label: 'Automatic Turn On/Off',
                    children: raw('<input class="edit-input" type="number" data-bind="value: automaticTurnOnOff" />'),
                })}
                            ${LpFormField({
                    label: 'Automatic Turn On',
                    children: raw('<input class="edit-input" type="number" data-bind="value: automaticTurnOn" />'),
                })}
                            ${LpFormField({
                    label: 'Automatic Turn Off',
                    children: raw('<input class="edit-input" type="number" data-bind="value: automaticTurnOff" />'),
                })}
                            ${LpFormField({
                    label: 'Notes',
                    className: 'edit-span',
                    children: raw('<textarea class="edit-input edit-textarea" rows="5" placeholder="Internal notes about this contract" data-bind="value: notes"></textarea>'),
                })}
                        `,
            }),
        })}

                ${LpEditSteps({})}
                </div>
            </div>
        `;
    }
    getPriceTiersTableHtml() {
        const columns = this.getPriceTierColumns();
        return renderKoDataTable({
            title: 'Price Tiers',
            caption: 'Contract price tiers',
            columns,
            className: 'contract-edit-table contract-edit-table--tiers',
            children: this.getPriceTiersTableBodyHtml(columns),
        });
    }
    getPriceTierColumns() {
        return [
            {
                key: 'tier',
                label: 'Tier',
                resizable: true,
                minWidth: 160,
            },
            {
                key: 'price',
                label: 'Price',
                resizable: true,
                width: 160,
                minWidth: 128,
            },
            {
                key: 'threshold',
                label: 'Threshold',
                resizable: true,
                width: 160,
                minWidth: 128,
            },
        ];
    }
    getPriceTiersTableBodyHtml(columns) {
        return LpTable.Body({
            attributes: {
                'data-bind': 'foreach: priceTiers',
            },
            children: LpTable.Row({
                children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'label' })}
                    ${this.getNumberInputCell(columns[1], 'price', '0.0001')}
                    ${this.getNumberInputCell(columns[2], 'threshold')}
                `,
            }),
        });
    }
    getMonthlyQuotasTableHtml() {
        const columns = this.getMonthlyQuotaColumns();
        return renderKoDataTable({
            title: 'Monthly Quotas',
            caption: 'Contract monthly quota settings',
            columns,
            className: 'contract-edit-table contract-edit-table--monthly',
            children: this.getMonthlyQuotasTableBodyHtml(columns),
        });
    }
    getMonthlyQuotaColumns() {
        return [
            {
                key: 'month',
                label: 'Month',
                resizable: true,
                minWidth: 140,
            },
            {
                key: 'target',
                label: 'Target Volume',
                resizable: true,
                width: 160,
                minWidth: 128,
            },
            {
                key: 'max',
                label: 'Max Volume',
                resizable: true,
                width: 160,
                minWidth: 128,
            },
            {
                key: 'sold',
                label: 'Sold Leads',
                resizable: true,
                width: 140,
                minWidth: 112,
            },
        ];
    }
    getMonthlyQuotasTableBodyHtml(columns) {
        return LpTable.Body({
            attributes: {
                'data-bind': 'foreach: monthlyQuotas',
            },
            children: LpTable.Row({
                children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'label' })}
                    ${this.getNumberInputCell(columns[1], 'target')}
                    ${this.getNumberInputCell(columns[2], 'max')}
                    ${renderRecruitingTextCell({ column: columns[3], binding: 'sold' })}
                `,
            }),
        });
    }
    getDailyQuotasTableHtml() {
        const columns = this.getDailyQuotaColumns();
        return renderKoDataTable({
            title: 'Daily Max Quota',
            caption: 'Contract daily max volume settings',
            columns,
            className: 'contract-edit-table contract-edit-table--daily',
            children: this.getDailyQuotasTableBodyHtml(columns),
        });
    }
    getDailyQuotaColumns() {
        return [
            {
                key: 'day',
                label: 'Day',
                resizable: true,
                minWidth: 140,
            },
            {
                key: 'max',
                label: 'Max Volume',
                resizable: true,
                width: 180,
                minWidth: 128,
            },
        ];
    }
    getDailyQuotasTableBodyHtml(columns) {
        return LpTable.Body({
            attributes: {
                'data-bind': 'foreach: dailyQuotas',
            },
            children: LpTable.Row({
                children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'label' })}
                    ${this.getNumberInputCell(columns[1], 'max')}
                `,
            }),
        });
    }
    getNumberInputCell(column, binding, step) {
        return renderKoInputCell({
            column,
            binding,
            type: 'number',
            step,
        });
    }
    /**
     * Activate a contract section tab.
     *
     * @param sectionId string
     * @return void
     */
    selectSection(sectionId) {
        this.getTemplateViewModel().activeSection(sectionId);
    }
    /**
     * Move to the previous section in the wizard flow.
     *
     * @return void
     */
    goToPreviousSection() {
        const vm = this.getTemplateViewModel();
        const index = this.getSectionIndex(vm.activeSection());
        if (index <= 0) {
            return;
        }
        vm.activeSection(this.getSectionIds()[index - 1]);
    }
    /**
     * Validate the current section and move to the next one for new contracts.
     *
     * @return void
     */
    goToNextSection() {
        const vm = this.getTemplateViewModel();
        const currentSection = vm.activeSection();
        if (!vm.id() && !this.validateSection(currentSection)) {
            return;
        }
        const index = this.getSectionIndex(currentSection);
        if (index >= this.getSectionIds().length - 1) {
            return;
        }
        vm.activeSection(this.getSectionIds()[index + 1]);
    }
    /**
     * Return ordered section ids.
     *
     * @return Array<string>
     */
    getSectionIds() {
        return (this.getTemplateViewModel().sections || []).map((section) => section.id);
    }
    /**
     * Return the index of a section id.
     *
     * @param sectionId string
     * @return number
     */
    getSectionIndex(sectionId) {
        return this.getSectionIds().indexOf(sectionId);
    }
    /**
     * Validate required fields for a section.
     *
     * @param sectionId string
     * @return boolean
     */
    validateSection(sectionId) {
        const vm = this.getTemplateViewModel();
        if (sectionId === 'campaign') {
            if (!String(vm.name() || '').trim()) {
                alert('Campaign name is required.');
                return false;
            }
            if (!vm.startDate() || !vm.endDate()) {
                alert('Start and end dates are required.');
                return false;
            }
        }
        if (sectionId === 'partners' && !this.normalizeArray(vm.selectedPartnerIds()).length) {
            alert('At least one partner is required.');
            return false;
        }
        return true;
    }
    /**
     * Return section completion flags for tab indicators.
     *
     * @return Record<string, boolean>
     */
    getSectionCompletion() {
        const vm = this.getTemplateViewModel();
        return {
            campaign: !!(String(vm.name() || '').trim() && vm.startDate() && vm.endDate()),
            partners: this.normalizeArray(vm.selectedPartnerIds()).length > 0,
            pricing: this.hasPricingValues(),
            quotas: this.hasQuotaValues(),
            automation: this.hasAutomationValues(),
        };
    }
    /**
     * Return whether pricing fields have values.
     *
     * @return boolean
     */
    hasPricingValues() {
        const vm = this.getTemplateViewModel();
        if (vm.priceFlat() || vm.deliveryMethod() || vm.badLeadsPercent() || vm.badLeadsFlat()) {
            return true;
        }
        return (vm.priceTiers() || []).some((tier) => tier.price() || tier.threshold());
    }
    /**
     * Return whether quota fields have values.
     *
     * @return boolean
     */
    hasQuotaValues() {
        const vm = this.getTemplateViewModel();
        if (vm.weeklyMaxVolume() || vm.dailyMaxVolume() || vm.targetLeadSold() || vm.uniqueLeads()) {
            return true;
        }
        if ((vm.monthlyQuotas() || []).some((quota) => quota.target() || quota.max())) {
            return true;
        }
        return (vm.dailyQuotas() || []).some((quota) => quota.max());
    }
    /**
     * Return whether automation fields have values.
     *
     * @return boolean
     */
    hasAutomationValues() {
        const vm = this.getTemplateViewModel();
        return !!(vm.quotaAlert()
            || vm.automaticTurnOnOff()
            || vm.automaticTurnOn()
            || vm.automaticTurnOff()
            || String(vm.notes() || '').trim());
    }
    /**
     * Apply reference data returned by the API to the view model.
     *
     * @param references any
     * @return void
     */
    setReferences(references) {
        references = references || {};
        const vm = this.getTemplateViewModel();
        const partners = this.normalizeOptions(references.partners);
        const channels = this.normalizeOptions(references.channels, [{ id: 'REC', name: 'Recruiting' }]);
        const agencies = this.normalizeOptions(references.agencies);
        const salesReps = this.normalizeOptions(references.salesReps);
        vm.partners(partners);
        vm.channels(channels);
        vm.agencies(agencies);
        vm.salesReps(salesReps);
        this.channelSelect.setOptions([
            { id: '', name: 'Select channel' },
            ...channels,
        ]);
        this.agencySelect.setOptions([
            { id: '', name: 'Select agency' },
            ...agencies,
        ]);
        this.salesRepSelect.setOptions([
            { id: '', name: 'Select sales rep' },
            ...salesReps,
        ]);
    }
    /**
     * Apply a contract DTO to the edit view model.
     *
     * @param contract any
     * @param duplicate boolean
     * @return void
     */
    setContract(contract, duplicate = false) {
        const vm = this.getTemplateViewModel();
        contract = contract || {};
        vm.id(duplicate ? null : (contract.id ? Number(contract.id) : null));
        vm.name(contract.name || '');
        vm.campaignCode(contract.campaignCode || '');
        vm.channel(contract.channel || 'REC');
        vm.startDate(duplicate ? '' : (contract.startDate || ''));
        vm.endDate(duplicate ? '' : (contract.endDate || ''));
        vm.agency(this.valueOrEmpty(contract.agency));
        vm.deliveryMethod(this.valueOrEmpty(contract.deliveryMethod));
        vm.salesRep(this.valueOrEmpty(contract.salesRep));
        vm.notes(duplicate ? '' : (contract.notes || ''));
        vm.weeklyMaxVolume(this.valueOrEmpty(contract.weeklyMaxVolume));
        vm.dailyMaxVolume(this.valueOrEmpty(contract.dailyMaxVolume));
        vm.targetLeadSold(this.valueOrEmpty(contract.targetLeadSold));
        vm.uniqueLeads(this.valueOrEmpty(contract.uniqueLeads));
        vm.badLeadsPercent(this.valueOrEmpty(contract.badLeadsPercent));
        vm.badLeadsFlat(this.valueOrEmpty(contract.badLeadsFlat));
        vm.quotaAlert(duplicate ? '' : this.valueOrEmpty(contract.quotaAlert));
        vm.automaticTurnOnOff(this.valueOrEmpty(contract.automaticTurnOnOff));
        vm.automaticTurnOn(this.valueOrEmpty(contract.automaticTurnOn, '1'));
        vm.automaticTurnOff(this.valueOrEmpty(contract.automaticTurnOff, '1'));
        vm.priceFlat(this.valueOrEmpty(contract.priceFlat));
        vm.selectedPartnerIds(this.normalizeArray(contract.partnerIds));
        vm.campaignCodesText((contract.campaignCodes || []).join('\n'));
        vm.currentTrackingMonths(duplicate ? [] : (contract.trackingMonths || []));
        this.setTierRows(contract);
        this.setMonthlyRows(contract, duplicate);
        this.setDailyRows(contract);
    }
    /**
     * Build the save payload from the current view model state.
     *
     * @return any
     */
    getPayload() {
        const vm = this.getTemplateViewModel();
        const payload = {
            id: vm.id(),
            name: vm.name(),
            campaignCode: vm.campaignCode(),
            channel: vm.channel(),
            startDate: vm.startDate(),
            endDate: vm.endDate(),
            agency: this.nullableValue(vm.agency()),
            deliveryMethod: this.nullableValue(vm.deliveryMethod()),
            salesRep: this.nullableValue(vm.salesRep()),
            notes: vm.notes(),
            weeklyMaxVolume: this.nullableValue(vm.weeklyMaxVolume()),
            dailyMaxVolume: this.nullableValue(vm.dailyMaxVolume()),
            targetLeadSold: this.nullableValue(vm.targetLeadSold()),
            uniqueLeads: this.nullableValue(vm.uniqueLeads()),
            badLeadsPercent: this.nullableValue(vm.badLeadsPercent()),
            badLeadsFlat: this.nullableValue(vm.badLeadsFlat()),
            quotaAlert: this.nullableValue(vm.quotaAlert()),
            automaticTurnOnOff: this.nullableValue(vm.automaticTurnOnOff()),
            automaticTurnOn: this.nullableValue(vm.automaticTurnOn()),
            automaticTurnOff: this.nullableValue(vm.automaticTurnOff()),
            priceFlat: this.nullableValue(vm.priceFlat()),
            partnerIds: this.normalizeArray(vm.selectedPartnerIds()).map((id) => Number(id)),
            campaignCodes: this.splitTextList(vm.campaignCodesText()),
            trackingMonths: [],
        };
        (vm.priceTiers() || []).forEach((tier) => {
            payload['price' + tier.index] = this.nullableValue(tier.price());
            payload['threshold' + tier.index] = this.nullableValue(tier.threshold());
        });
        (vm.monthlyQuotas() || []).forEach((quota) => {
            payload['monthlyTargetQuota' + quota.index] = this.nullableValue(quota.target());
            payload['monthlyMaxQuota' + quota.index] = this.nullableValue(quota.max());
        });
        (vm.dailyQuotas() || []).forEach((quota) => {
            payload['dailyMaxVolume' + quota.index] = this.nullableValue(quota.max());
        });
        return payload;
    }
    /**
     * Return price tier rows.
     *
     * @return Array<any>
     */
    getPriceTierRows() {
        const rows = [];
        for (let i = 1; i <= 4; i++) {
            rows.push({ index: i, label: 'Tier ' + i, price: ko.observable(''), threshold: ko.observable('') });
        }
        return rows;
    }
    /**
     * Return monthly quota rows.
     *
     * @return Array<any>
     */
    getMonthlyQuotaRows() {
        return [];
    }
    /**
     * Return daily quota rows.
     *
     * @return Array<any>
     */
    getDailyQuotaRows() {
        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return dayNames.map((name, index) => ({
            index: index + 1,
            label: name,
            max: ko.observable(''),
        }));
    }
    /**
     * Set tier rows on the view model.
     *
     * @param contract any
     * @return void
     */
    setTierRows(contract) {
        (this.getTemplateViewModel().priceTiers() || []).forEach((tier) => {
            tier.price(this.valueOrEmpty(contract['price' + tier.index]));
            tier.threshold(this.valueOrEmpty(contract['threshold' + tier.index]));
        });
    }
    /**
     * Set monthly rows on the view model.
     *
     * @param contract any
     * @param duplicate boolean
     * @return void
     */
    setMonthlyRows(contract, duplicate) {
        const trackingMonths = contract.trackingMonths || [];
        const rows = this.buildMonthlyQuotaRows(contract.startDate || '', contract.endDate || '', contract, duplicate ? [] : trackingMonths);
        this.getTemplateViewModel().monthlyQuotas(rows);
    }
    /**
     * Refresh monthly rows after date edits.
     *
     * @param vm any
     * @return void
     */
    refreshMonthlyRows(vm) {
        vm.monthlyQuotas(this.buildMonthlyQuotaRows(vm.startDate(), vm.endDate(), this.buildMonthlyQuotaValuesFromRows(vm.monthlyQuotas()), vm.currentTrackingMonths()));
    }
    /**
     * Return monthly quota rows for the exact contract month range.
     *
     * @param startDateValue string
     * @param endDateValue string
     * @param quotaValues any
     * @param trackingMonths Array<any>
     * @return Array<any>
     */
    buildMonthlyQuotaRows(startDateValue, endDateValue, quotaValues, trackingMonths) {
        const startDate = this.parseDateInput(startDateValue);
        const endDate = this.parseDateInput(endDateValue);
        if (!startDate || !endDate || startDate > endDate) {
            return [];
        }
        const rows = [];
        const cursor = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        const endMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        while (cursor <= endMonth) {
            const monthIndex = cursor.getMonth() + 1;
            const yyyymm = String(cursor.getFullYear()) + this.padNumber(monthIndex, 2);
            rows.push({
                index: monthIndex,
                yyyymm: yyyymm,
                label: this.formatMonthLabel(cursor),
                target: ko.observable(this.valueOrEmpty(quotaValues['monthlyTargetQuota' + monthIndex])),
                max: ko.observable(this.valueOrEmpty(quotaValues['monthlyMaxQuota' + monthIndex])),
                sold: ko.observable(this.getLeadsSentAdjustedForMonth(trackingMonths, yyyymm)),
            });
            cursor.setMonth(cursor.getMonth() + 1);
        }
        return rows;
    }
    /**
     * Return month-of-year quota values from current rows.
     *
     * @param rows Array<any>
     * @return any
     */
    buildMonthlyQuotaValuesFromRows(rows) {
        const values = {};
        (rows || []).forEach((quota) => {
            values['monthlyTargetQuota' + quota.index] = quota.target();
            values['monthlyMaxQuota' + quota.index] = quota.max();
        });
        return values;
    }
    /**
     * Set daily rows on the view model.
     *
     * @param contract any
     * @return void
     */
    setDailyRows(contract) {
        (this.getTemplateViewModel().dailyQuotas() || []).forEach((quota) => {
            quota.max(this.valueOrEmpty(contract['dailyMaxVolume' + quota.index]));
        });
    }
    /**
     * Return leads sent adjusted for exact yyyymm.
     *
     * @param trackingMonths Array<any>
     * @param yyyymm string
     * @return string
     */
    getLeadsSentAdjustedForMonth(trackingMonths, yyyymm) {
        const month = (trackingMonths || []).filter((row) => {
            const value = String(row.month || (row.id ? row.id.date : '') || '');
            return value === yyyymm;
        })[0];
        return month && typeof month.leadsSentAdjusted !== 'undefined' && month.leadsSentAdjusted !== null ? String(month.leadsSentAdjusted) : '';
    }
    /**
     * Parse an input date value without timezone conversion.
     *
     * @param value string
     * @return Date|null
     */
    parseDateInput(value) {
        const matches = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!matches) {
            return null;
        }
        return new Date(Number(matches[1]), Number(matches[2]) - 1, Number(matches[3]));
    }
    /**
     * Return a month label with year context.
     *
     * @param date Date
     * @return string
     */
    formatMonthLabel(date) {
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return monthNames[date.getMonth()] + ' ' + date.getFullYear();
    }
    /**
     * Pad a number with leading zeroes.
     *
     * @param value number
     * @param length number
     * @return string
     */
    padNumber(value, length) {
        let padded = String(value);
        while (padded.length < length) {
            padded = '0' + padded;
        }
        return padded;
    }
    /**
     * Handle normalize options.
     *
     * @param options any
     * @param fallback Array<any>
     * @return Array<any>
     */
    normalizeOptions(options, fallback = []) {
        let rows = Array.isArray(options) ? options : [];
        if (!rows.length) {
            rows = fallback;
        }
        return rows.map((option) => ({
            id: String(typeof option.id !== 'undefined' ? option.id : option.code),
            name: String(option.name || option.label || option.value || option.id || ''),
        }));
    }
    /**
     * Handle normalize array.
     *
     * @param value any
     * @return Array<string>
     */
    normalizeArray(value) {
        const values = Array.isArray(value) ? value : [value];
        return values
            .filter((item) => item !== null && typeof item !== 'undefined' && item !== '')
            .map((item) => String(item));
    }
    /**
     * Handle split text list.
     *
     * @param value string
     * @return Array<string>
     */
    splitTextList(value) {
        return String(value || '')
            .split(/[\r\n,]+/)
            .map((item) => item.trim())
            .filter((item) => item !== '');
    }
    /**
     * Handle value or empty.
     *
     * @param value any
     * @param fallback any
     * @return any
     */
    valueOrEmpty(value, fallback = '') {
        return value !== null && typeof value !== 'undefined' ? value : fallback;
    }
    /**
     * Handle nullable value.
     *
     * @param value any
     * @return any
     */
    nullableValue(value) {
        return value === '' || value === null || typeof value === 'undefined' ? null : value;
    }
}
